import { render, staticRenderFns } from "./mapaestatistico.vue?vue&type=template&id=325f3ff1&"
import script from "./mapaestatistico.vue?vue&type=script&lang=js&"
export * from "./mapaestatistico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports